import { getServerApi } from '@/gql';
import { Lazbubu } from '@/gql/graph/__generated__/request';
import user from '@/stores/user';
import { useEffect, useState } from 'react';

export interface UseLazbubuResult {
    lazbubu: Lazbubu | null;
    loading: boolean;
    error: Error | null;
    refetch: () => Promise<Lazbubu | null>;
}

export const useLazbubu = (tokenId: number): UseLazbubuResult => {
    const [lazbubu, setLazbubu] = useState<Lazbubu | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<Error | null>(null);
    const { userId } = user;

    const getLazbubu = async () => {
        if (!tokenId || !userId) {
            setLazbubu(null);
            return null;
        }
        try {
            setLoading(true);
            setError(null);
            const api = getServerApi();
            const response = await api.lazbubu({
                tokenId: tokenId,
            });
            if (response?.lazbubu !== undefined) {
                setLazbubu(response.lazbubu);
                return response.lazbubu;
            } else {
                setLazbubu(null);
                return null;
            }
        } catch (err) {
            console.error('Failed to fetch lazbubu:', err);
            setError(
                err instanceof Error
                    ? err
                    : new Error('Failed to fetch lazbubu'),
            );
            setLazbubu(null);
            return null;
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getLazbubu();
    }, [tokenId, userId]);

    return {
        lazbubu,
        loading,
        error,
        refetch: getLazbubu,
    };
};
